import * as _ from 'lodash';

import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { doGetPromise } from '../../../core/config/core.httpclient-utils';
import { UserService } from '../../../core/services/core.user.service';
import { UserRest } from '../../../core/services/core.user.rest.service';




@Injectable()
export class ChatMacroService {

    constructor(
        private http: HttpClient,
        private userService: UserService,
        private userRest: UserRest
    ) {
        this.http = http;
    }

    parseMacro = (body: string) => {
        // var regex = /^\/(\w)(*.)/;
        if (body && body.startsWith('/')) {
            const pieces = body.slice(1).split(' ');
            if (pieces && pieces.length) {
                return {
                    name: this.getMacroName(pieces),
                    args: this.getMacroParams(pieces)
                };
            }
        }
        return false;
    };

    getMacroName = (pieces: any) => {
        return _.get(pieces, '[0]');
    };

    getMacroParams = (pieces: any) => {
        return pieces.slice(1);
    };

    hasMacro = (body: any) => {
        const name = _.get(this.getMacro(body), 'name', false);
        return _.has(this.macros, name);
    };

    getMacro = (body: any) => {
        return this.parseMacro(body);
    };

    callMacro = (body: any) => {
        var macro = this.getMacro(body);
        if (macro) {
            const f = _.get(this.macros, macro.name);
            if (f) {
                return f(macro);
            }
        }
        return Promise.reject("Invalid macro");
    };

    callAPIMacro = (macro: any) => {
        return new Promise((resolve, reject) => {

            const url = "/site/macro/" + macro.name;

            this.http.post(url, { params: macro.args.join(' ') } )
                .toPromise()
                .then(
                    (response) => {
                        macro.response = response;
                        resolve(macro);
                    },
                    (response) => {
                        console.log('macro POST fail', url, response);
                        reject(response);
                    }
                );
        });
    };

    createMacroChatMessage = (macro: any) => {

        const now = new Date();
        const ticks = now.getTime();

        const msg = {
            body: macro.body,
            // Macro responses are HTML this service builds itself (see
            // getHelpResponse et al)
            isMarkdown: false,
            date: now.toISOString(),
            id: ticks,
            subtype: macro.name,
            trackby: "macro-" + ticks,
            type: "macro",
            data: macro,
            user: this.userService.session.getUser()
        };

        return msg;
    };

    getHelpResponse = (macro: any) => {
        // Blank out any args
        macro.args = [];
        macro.body = '\
                <dl class="command-list">\
                    <dt>/help, /?</dt>\
                    <dd>This help info - list available macros</dd>\
                    <dt>/mdn [search term(s)]</dt>\
                    <dd>MDN (Mozilla) search</dd>\
                    <dt>/ms [search term(s)]</dt>\
                    <dd>Microsoft (site) search</dd>\
                    <dt>/so [search term(s)]</dt>\
                    <dd>StackOverflow search</dd>\
                    <dt>/wp [search term(s)]</dt>\
                    <dd>Wikipedia search</dd>\
                    <dt>/msg, /wall [user] [msg]</dt>\
                    <dd>Send a private msg to the specified GForge Next username</dd>\
                    <dt>/queue, /q [list|add|remove] [id]</dt>\
                    <dd>List items in queue, add or remove by ID</dd>\
                </dl>\
            ';

        return this.createMacroChatMessage(macro);
    };

    macros = {
        ddg: (macro: any) => {
            // https://api.duckduckgo.com/?q=Eastman+Kodak&format=json
            return false;
        },
        msg: (macro: any) => {
            return new Promise((resolve, reject) => {

                const args = _.get(macro, 'args', []);
                const name = _.get(macro, 'name', 'msg');

                if (args.length < 2) {
                    macro.body = '<p>/' + name + '</p><p><em>Usage: /msg unixName msg</em></p>';
                    return resolve(
                        this.createMacroChatMessage(macro)
                    );
                }

                this.callAPIMacro(macro)
                    .then(
                        (response: any) => {
                            // List the URLs from the responses
                            // pre-rendering will convert them to URL previews
                            response.body = '<p><em>To ' + args[0] + ':</em></p>' +
                                _.get(response, 'response', '');

                            resolve(
                                this.createMacroChatMessage(response)
                            );
                        },
                        (response) => {
                            console.log('msg callAPIMacro fail', response);
                            reject(false);
                        }
                    );
            });
        },
        wall: (macro: any) => {
            return this.macros.msg(macro);
        },

        queue: (macro: any) => {

            return new Promise((resolve, reject) => {

                const args = _.get(macro, 'args', []);
                const user = { unixName: this.userService.session.getUnixName() };
                let promise;
                var caption = '';

                if (args.length == 2) {
                    const action = _.toLower(args[0]);
                    const id = args[1].replace('#', '');  // remove pound sign if present
                    // add or remove
                    if (action == 'add') {
                        promise = this.addToQueue(user, id);
                    } else if (action == 'remove') {
                        promise = this.removeFromQueue(user, id);
                    }
                } else {
                    promise = Promise.resolve('Your current queue');
                }

                promise.then(
                    (result) => {
                        caption = result;
                    },
                    (result) => {
                        caption = result;
                    }
                ).finally(
                    () => {
                        this.userRest.getQueue(user.unixName)
                            .then(
                                (response: any) => {
                                    response.body = caption + "<br />" +
                                        this.getTITable(_.get(response, 'items', []));

                                    const msg = this.createMacroChatMessage(response);
                                    resolve(msg);
                                },
                                (response) => {
                                    console.log(response);
                                    reject(macro);
                                }
                            );
                    }
                );
            });
        },
        
        q: (macro: any) => { return this.macros.queue(macro); },

        mdn: (macro: any) => {
            return new Promise((resolve, reject) => {

                this.callAPIMacro(macro)
                    .then(
                        (response: any) => {
                            // List the URLs from the responses
                            // pre-rendering will convert them to URL previews
                            response.body = '<p>Mozilla Developer Network search: ' + macro.args.join(' ') + '</p>' +
                                _.map(
                                    _.get(response, 'response', []),
                                    'url'
                                ).join(' ');

                            resolve(
                                this.createMacroChatMessage(response)
                            );
                        },
                        (response) => {
                            console.log('mdn callAPIMacro fail', response);
                            reject(false);
                        }
                    );
            });
        },

        ms: (macro: any) => {
            return new Promise((resolve, reject) => {

                const params = {
                    scoringprofile: 'semantic-captions',
                    facet: ['category', 'products'],
                    top: '5',
                    expandScope: 'true',
                    search: macro.args.join(' '),
                    locale: this.getLocaleString()
                };

                const url = 'https://docs.microsoft.com/api/search';

                doGetPromise(this.http, url, params)
                    .then(
                        (response: any) => {
                            response.body = '<p>Microsoft Docs search: ' + macro.args.join(' ') + '</p>' +
                                _.map(
                                    _.slice(_.get(response, 'results', []), 0, 5),
                                    'url'
                                ).join(' ');

                            resolve(
                                this.createMacroChatMessage(response)
                            );
                        },
                        (response) => {
                            reject(false);
                        }
                    );
            });
        },

        so: (macro: any) => {
            return new Promise((resolve, reject) => {

                const url = 'https://api.stackexchange.com/2.2/search/advanced?pagesize=5&site=stackoverflow&q=';
                const q = _.get(macro, 'args', []).join(' ');

                if (q.length > 0) {
                    doGetPromise(this.http, url + encodeURIComponent(q))
                        .then(
                            (response) => {
                                // List the URLs from the responses
                                // pre-rendering will convert them to URL previews
                                macro.body = '<p>StackOverflow search: ' + macro.args.join(' ') + '</p>' +
                                    _.map(
                                        _.get(response, 'items', []),
                                        'link'
                                    ).join(' ');

                                resolve(
                                    this.createMacroChatMessage(macro)
                                );
                            },
                            (response) => {
                                reject(false);
                            }
                        )
                }
            });
        },

        help: (macro: any) => {
            return Promise.resolve(
                this.getHelpResponse(macro)
            );
        },
        '?': (macro: any) => {
            return Promise.resolve(
                this.getHelpResponse(macro)
            );
        },

        test: (macro: any) => {
            return macro;
        },

        wp: (macro: any) => {
            return new Promise((resolve, reject) => {

                this.callAPIMacro(macro)
                    .then(
                        (response: any) => {
                            // List the URLs from the responses
                            // pre-rendering will convert them to URL previews
                            response.body = '<p>Wikipedia search: ' + macro.args.join(' ') + '</p>' +
                                _.map(
                                    _.get(response, 'response', []),
                                    'url'
                                ).join(' ');

                            resolve(
                                this.createMacroChatMessage(response)
                            );
                        },
                        (response) => {
                            reject(false);
                        }
                    );
            });
        }
    }

    addToQueue = (user: any, id: any) => {
        return new Promise((resolve, reject) => {
            const params = {
                tracker_item_id: id
            };

            this.userRest.postQueue(user.unixName, params)
                .then(
                    () => {
                        resolve('Added #' + id + ' to your queue');
                    },
                    (response) => {
                        reject('Sorry, could not add #' + id + ' to your queue');
                    }
                );
        });
    }

    removeFromQueue = (user: any, id: any) => {
        return new Promise((resolve, reject) => {
            const params = {
                tracker_item_id: id
            };

            this.userRest.removeFromQueue(user.unixName, params)
                .then(
                    () => {
                        resolve('Removed #' + id + ' from your queue');
                    },
                    (response) => {
                        reject('Sorry, could not remove #' + id + ' from your queue');
                    }
                );
        });
    }

    getTITable = (list: any) => {
        const table = _.template(
            '<table class="table table-hover"><thead><tr><th>ID</th><th>Summary</th><th>In</th></tr></thead><tbody>${ rows }</tbody></table>'
        );

        const row = _.template(
            '<tr><td>#${ id }</td><td><div>${ summary }</div></td><td><div>${ tracker.project.name } / ${ tracker.trackerName }</div></tr>'
        );

        return table({ rows: _.map(list, row) });
    }

    getLocaleString = () => {
        var tmpl = _.template('${ language }-${ ccode }');

        var ret = tmpl(this.userService.session.getUser());
        if (ret.length == 5) return ret;

        return 'en-US';
    }
}